import { render, staticRenderFns } from "./bkAddToFamily.vue?vue&type=template&id=6fd2c238&scoped=true"
import script from "./bkAddToFamily.vue?vue&type=script&lang=js"
export * from "./bkAddToFamily.vue?vue&type=script&lang=js"
import style0 from "./bkAddToFamily.vue?vue&type=style&index=0&id=6fd2c238&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd2c238",
  null
  
)

export default component.exports